import { PathnameEnum } from '@constant';
import { useOutput } from '@hooks';
import { colorSet } from '@theme';
import { IImageListItem } from '@types';
import { Frame, Text, ImageModal, ImageListItemComponent, LoadingSpinner } from '..';

interface IOutputProps {
  padding?: string;
  columnNum?: number;
}

export const Output = (props: IOutputProps) => {
  const { padding = '48px 40px 96px 40px', columnNum = 6 } = props;

  const {
    locationPathname,
    data,
    isLoading,
    flattenImageList,
    outputBottomRef,
    createQueryStringForImageList,

    handleImageClick,
    handleImageModalClose,

    handleImageUseButtonClick
  } = useOutput();

  const isStandardOutputPage = locationPathname === PathnameEnum.STANDARD_OUTPUT_PAGE;
  const isAdultsOnlyOutputPage = locationPathname === PathnameEnum.ADULTS_ONLY_OUTPUT_PAGE;

  const gap = isAdultsOnlyOutputPage ? 4 : 10;
  const itemNumberPerRow = isStandardOutputPage ? columnNum : 6;
  const sumOfHorizontalGaps = gap * (itemNumberPerRow - 1);
  const itemSize = `calc((100% - ${sumOfHorizontalGaps}px) / ${itemNumberPerRow})`;

  return (
    <>
      <Frame width="100%" padding={padding}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: `${gap}px`,
            width: '100%',
            boxSizing: 'border-box'
          }}
        >
          {data &&
            flattenImageList.length > 0 &&
            flattenImageList.map((item: IImageListItem, index) => {
              return (
                <ImageListItemComponent
                  key={`${item.id}_${index}`}
                  item={item}
                  itemSize={itemSize}
                  onImageClick={handleImageClick}
                  onUseButtonClick={handleImageUseButtonClick}
                  createQueryStringForImageList={createQueryStringForImageList}
                />
              );
            })}
        </div>
        <div ref={outputBottomRef} />

        {(!data || flattenImageList.length === 0) && (
          <div
            style={{
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <Text variant="body1" color={colorSet.gray500}>
                검색된 이미지가 없습니다.
              </Text>
            )}
          </div>
        )}
      </Frame>

      <ImageModal
        onClose={handleImageModalClose}
        onUseButtonClick={handleImageUseButtonClick}
        createQueryStringForImageList={createQueryStringForImageList}
      />
    </>
  );
};
